angular.module('picmonic-common').factory('ReferralResource', [
  '$resource',
  function ($resource) {
    return $resource('/api/v3/referrals/:referral_code', {
      referral_code: '@referral_code',
    });
  },
]);
